<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <div class="matrix_packingOptionLabel">
      {{ name }}
    </div>
    <input
      :value="option"
      type="text"
      @keydown.enter="
        event => {
          event.preventDefault();
        }
      "
      @change="updateOption"
    />
  </div>
</template>
<script>
import { usePackingOptionsStore } from "@/stores/modules/packingOptions";
import { mapState, mapActions } from "pinia";

import { i18n } from "../../i18n.js";
import { validateInput } from "../../helpers/helpers";
import { useWebproductStore } from "@/stores/modules/webproduct";

export default {
  computed: {
    ...mapState(usePackingOptionsStore, ["getPackingOptions", "getLimits"]),
    ...mapState(useWebproductStore, ["getSweetAlert"]),
    name: function () {
      return i18n.t("pv_" + this.propsData.label);
    },
    option() {
      return this.propsData.value;
    }
  },
  methods: {
    ...mapActions(usePackingOptionsStore, ["setPackingOption"]),
    updateOption(event) {
      var newValue = event.target.value;
      var attribute = this.propsData.code.replace("packing_format_", "");
      var min = null;
      var max = null;
      if (this.getLimits[attribute]) {
        min = this.getLimits[attribute].min;
        max = this.getLimits[attribute].max;
      }
      var optionValid = validateInput(newValue, this.propsData.label, min, max);
      if (!optionValid.valid) {
        this.getSweetAlert({ text: optionValid.msg, icon: "warning" });
        this.setPackingOption({
          code: this.propsData.code,
          value: this.propsData.value
        });
        return;
      }
      this.setPackingOption({
        code: this.propsData.code,
        value: newValue
      });
    }
  },
  props: ["propsData"]
};
</script>
